import getOutletIds from '../../app/utils/getOutletIds'
import getTenantIds from '../../app/utils/getTenantIds'

/**
 * Generates query parameters for gift card addon API from the white-label tenants.
 * @example
 * {
 *  tenantId: 'tenant-123',
 *  outletIds[0]: 'outlet-456',
 *  outletIds[1]: 'outlet-789',
 * }
 */
function getGiftCardAddonTenantOutletQueryParams() {
  const queryParams: Record<string, string> = {}

  const tenantIds = getTenantIds(false)
  const outletIds = getOutletIds()

  const hasTenantIds = !!tenantIds?.length
  const hasOutletIds = !!outletIds?.length

  if (hasTenantIds) {
    const [tenantId] = tenantIds
    queryParams.tenantId = tenantId
  }

  if (hasOutletIds) {
    const outletIdsParams = outletIds.reduce<Record<string, string>>(
      (acc, outletId, i) => {
        acc[`outletIds[${i}]`] = outletId
        return acc
      },
      {},
    )
    Object.assign(queryParams, outletIdsParams)
  }

  return queryParams
}

export default getGiftCardAddonTenantOutletQueryParams
